<template>
<transition v-if="!$store.state.clinicHistory.sidebarHidden" name="fade" mode="out-in">
    <div role="dialog" :style="containerStyle" aria-modal="false" class="b-sidebar shadow bg-light text-dark sidebar-shadow" :class="containerClass">
        <div class="b-sidebar-body">
            <div :class="expanded ? 'p-3 text-center' : ''"> 
                <nav :style="navStyle" class="sidebar-history">
                    <ul class="nav flex-column" :class="{'ul-right': rightSide}">
                        <li v-for="item in sidebarData" :key="item.title" :style="liStyle">
                            <a v-if="expanded" @click.prevent="rightSide ? item.action() : goToSection(item.id)" class="nav-link" :title="item.title" href="" :style="liSpanStyle">
                                <!-- <base-icon :src="`${iconBasePath}${item.id}.svg`" :alt="item.title" :title="item.title" :height="iconSize" :width="iconSize" :color="BLUE_COLOUR" class="cursor-pointer"></base-icon> -->
                                <b v-html="item.title"></b>
                            </a>
                            <span v-else class="icon-in-li" @click="rightSide ? item.action() : goToSection(item.id)" :style="liSpanStyle">
                                <base-icon :src="`${iconBasePath}${item.id}.svg`" :alt="item.title" :title="item.title" :height="iconSize" :width="iconSize" :color="BLUE_COLOUR" class="cursor-pointer"></base-icon>
                            </span>
                            <hr v-if="!item.hideHr" class="history-sidebar-hr">
                        </li>
                    </ul>
                </nav>
                <!--
                    <div :style="{'bottom': `${marginTop + 6}px`}" class="sidebar-collapsed-arrow">
                        <b-icon-arrow-bar-right v-if="showCollapseArrow" scale="1.5"></b-icon-arrow-bar-right>
                    </div>
                -->
            </div>
        </div>
    </div>
</transition>
</template>

<script>
import { BSidebar, BNavbar, BNavItem, BNav } from 'bootstrap-vue'
import BaseButton from '../base/buttons/BaseButton.vue'
import { BLUE_COLOUR } from '@/constants/colours'
import { BASE_PATH, HEALTH_VARS_PATH } from '@/constants/clinicHistory'

export default {
    components: {
        BSidebar,
        BNavbar,
        BNavItem,
        BaseButton,
        BNav
    },
    props: {
        rightSide: Boolean,
        sidebarData: Object,
        defaultLiHeight: Number
    },
    data () {
        return {
            BLUE_COLOUR,
            marginTop: 0,
            sidebarHeight: null,
            sidebarMargin: 0,
            sidebarWidth: 'auto',
            liHeight: null,
            topMarginBackBtn: null,
            loadCompleted: false,
            heightLimitExpanded: 550,
            widthLimitExpanded: 1650,
            scTimer: 0,
            position: 'fixed'
        }
    },
    methods: {
        goToSection (section) {
            this.$emit('openHistorySection', section)
            document.querySelector(`#${section}`).scrollIntoView({
                behavior: 'smooth'
            })
        },
        handleScroll: function () {
            if (location.href.indexOf(`${BASE_PATH}/${HEALTH_VARS_PATH}`) === -1) {
                window.removeEventListener('scroll', this.handleScroll)
                return
            }
            if (this.scTimer) return
            this.scTimer = setTimeout(() => {
                let scY = document.getElementById('familyBackground').getBoundingClientRect().top - window.scrollY
                clearTimeout(this.scTimer)
                this.scTimer = 0
                this.$store.state.clinicHistory.sidebarHidden = scY < 0
            }, 100)
        }
    },
    mounted () {
        let _this = this
        setTimeout(() => {
            this.$store.state.clinicHistory.sidebarHidden = window.innerHeight < this.heightLimitExpanded || !this.expanded
            if (this.$store.state.clinicHistory.sidebarHidden) {
                return
            }
            let innerContainer = document.getElementById('history-container')
            this.marginTop = parseInt(innerContainer.offsetTop)
            this.sidebarHeight = parseInt(document.getElementsByClassName('b-sidebar-body')[0].offsetHeight) - this.marginTop - (this.expanded ? 30 : 0)
            let sidebarWidth = parseInt(document.getElementsByClassName('b-sidebar')[0].offsetWidth)
            let containerWidth = parseInt(window.getComputedStyle(document.getElementById('history-view-container')).width.replace('px', '')) - (2 * sidebarWidth)
            this.liHeight = this.defaultLiHeight ? this.defaultLiHeight : (this.sidebarHeight / Object.keys(this.sidebarData).length) - 0.5
            let containerMarginLeft = parseInt(window.getComputedStyle(document.getElementsByClassName('custom-container')[0]).paddingLeft.replace('px', ''))
            this.sidebarMargin = containerMarginLeft
            innerContainer.style.width = `${containerWidth}px`
            document.getElementById('history-view-container').style.display = 'flex'
            document.getElementById('history-view-container').style['justify-content'] = 'center'
            let sideUlright = parseInt(document.querySelector('.b-sidebar-body ul').offsetHeight)
            this.topMarginBackBtn = Math.min(this.sidebarHeight, sideUlright) + this.marginTopByDevice
            this.position = 'sticky'
            this.loadCompleted = true
            // window.addEventListener('scroll', this.handleScroll)
            if (!this.rightSide) this.$emit('liHeight', this.liHeight)
        }, 300)
        window.removeEventListener('orientationchange')
        window.addEventListener('orientationchange', function (event) {
            _this.$emit('refreshSidebar')
        })
    },
    computed: {
        containerStyle () {
            return {'width': `${!this.expanded ? this.sidebarCollapsedWidth : this.sidebarWidth}px`, 'top': `${this.marginTop}px`, 'height': `calc(100vh - ${this.marginTop + 20}px)`, position: this.position}
        },
        containerClass () {
            return {hidden: !this.loadCompleted, 'b-sidebar-right': this.rightSide}
        },
        navStyle () {
            return {'height': `${this.sidebarHeight}px`}
        },
        liStyle () {
            return {height: `${this.liHeight}px`}
        },
        liSpanStyle () {
            return {height: `${this.liHeight - 10}px`}
        },
        historyMenuPath () {
            return `${this.historyBasePath}${!this.$store.getters['session/userIsPatient'] ? `?patientId=${this.$route.query.patientId}` : ''}`
        },
        iconBasePath () {
            return '/static-appopensalud/img/icons/history-sidebar/'
        },
        historyBasePath () {
            return BASE_PATH
        },
        iconSize () {
            return this.$uiHelpers.isMobileOrTablet ? '20' : '21'
        },
        sidebarCollapsedWidth () {
            return this.$uiHelpers.isMobileOrTablet ? '28' : '45'
        },
        sidebarFooter () {
            return this.expanded ? 50 : 45
        },
        marginTopByDevice () {
            return this.expanded ? 20 : 10
        },
        expanded () {
            return window.innerWidth >= this.widthLimitExpanded
        }
    }
}
</script>

<style scoped lang="scss">
#history-view-container{
    .sidebar-history{
    overflow: scroll;
    &::-webkit-scrollbar { 
        display: none;
    }
    .nav li {
        &:first-child{
            margin-top: 5px;
        }
        .nav-link{
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
    }
    .history-sidebar-hr{
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
    }
    .sidebar-collapsed-arrow{
        cursor: pointer;
        position: fixed;
        /* bottom: 165px; */
        right: 15px;
    }
    .sidebar-arrow{
        cursor: pointer;
        position: fixed;
        /* bottom: 180px; */
        right: 25px;
    }
    .sidebar-back-btn{
        position: fixed;
        left: 50%;
        transform: translateX(-50%);
    }
    .sidebar-back-btn-collapsed{
        left: 50%;
        transform: translateX(-50%);
        padding: 0.2rem 0.4rem;
        @include media(mobile){
            padding: 0.1rem 0.2rem;
        }
    }
    .cursor-pointer{
        cursor: pointer;
    }
    .back-btn-collapsed-container{
        height: 30px;
        position: fixed;
        left: 50%;
        transform: translate(-50%, 0);
        /* bottom: 58px; */
    }
    .b-sidebar-body{
        position: relative;
    }
    .b-sidebar{
        text-align: center;
        background-color: $white !important;
        z-index: 1;
        border-radius: 23px;
    }
    .hidden{
        visibility: hidden;
    }
    .icon-in-li{
    display: flex;
    align-items: center;
    justify-content: center;
    }
    .sidebar-shadow{
        box-shadow: -10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784) !important
    }
    .ul-right{
        @include media(mobile, tablets) {
            margin-top: 1rem;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/layouts/ClinicHistorySectionsSidebar.vue